import React from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
const Footer = () => {
  return (
    <>
      <footer>
        <div className="footer-area footer-bg">
          <div className="footer-top">
          <div class="abs-list ftrShape1"></div>
            <div className="container-fluid fulwdh">
              <div className="row">
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <div className="fw-logo">
                      <Link to="/">
                     <LazyLoad>   <img
                          src="https://webapi.entab.info/api/image/SHSSB/public/Images/logo.png"
                          alt=""
                          className="img-fluid mx-auto d-block"
                        /></LazyLoad>
                      </Link>
                      <div class="footer-content">
                        <p>Sacred Heart School (Affiliated to C.I.S.C.E) serves students from Ballia city and the nearby villages. </p>
                        <ul class="list-wrap">
                          <li>
                            <a
                              href="https://www.youtube.com/channel/UCnrxNoilvvfpBHLJNoZR14Q"
                              target="_blank"
                            >
                              <i class="bi bi-youtube"></i>
                            </a>
                          </li>
                        </ul>{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-6 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <div className="fw-title">
                      <h4 className="title">Quick Links</h4>
                    </div>
                    <div className="fw-link">
                      <ul className="list-wrap">
                      <li>
                        <Link to="/Gallery"> Gallery</Link>
                      </li> 
                      <li>
                      <Link to="/Events">Events</Link>
                    </li> 
                        <li>
                          <Link to="/Tc">TC   </Link>
                        </li>  
                      <li>
                      <Link to="/Pphelp"> Portal (Help?)   </Link>
                    </li> 
                    <li>
                    <Link to="/ErpSoftware">ERP Software </Link>
                  </li> 
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <div className="fw-title">
                      <h4 className="title">Connect Us</h4>
                    </div>
                    <div className="fw-link">
                      <p>
                        <i class="bi bi-geo-alt-fill"></i><Link to="https://maps.app.goo.gl/3iGXkDrw5wScqMPt5" target="_blank"> NH-31,Saharaspali
                        Ballia -(U.P), Pincode-277001 </Link>
                      </p>
                      <p>
                        <i class="bi bi-telephone-fill"></i><Link to="tel:09721014086"> 09721014086 </Link>
                      </p>
                      <p>
                        <i class="bi bi-envelope-fill"></i> <Link to="mail:sacredheartschool.ballia@gmail.com">sacredheartschool.ballia@gmail.com</Link>
                        
                      </p>
                    </div>
                    <div class="card-body">
                      <h5>Download App</h5>
                      <h5>
                        Use URL:{" "}
                        <a
                          href="https://shsb.campussoft.net/"
                          target="_blank"
                        >
                          shsb.campussoft.net
                        </a>
                      </h5>
                      <a
                        href="https://apps.apple.com/in/app/campuscare/id1034721587?platform=ipad&preserveScrollPosition=true#platform/ipad"
                        target="_blank"
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://webapi.entab.info/api/image/SHSSB/public/Images/ios.png"
                            width="100px"
                            class="img-fluid icons"
                            alt="Sacred Heart Convent School"
                          />
                        </LazyLoad>
                      </a>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.campuscare.entab.ui"
                        target="_blank"
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://webapi.entab.info/api/image/SHSSB/public/Images/android.png"
                            class="img-fluid icons"
                            alt="Sacred Heart Convent School"
                          />
                        </LazyLoad>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12">
                  <div className="footer-widget">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3593.276511230866!2d84.185167315456!3d25.76142881489821!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399263606b918f27%3A0xfd74c48178e12545!2sSacred%20Heart%20School!5e0!3m2!1sen!2sin!4v1625286339817!5m2!1sen!2sin"
                      width="100%"
                      height="280"
                      style={{ border: "0" }}
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="copyright-text">
                    <p>
                      © 2024 All Copyright Reserved{" "}
                      <span>
                        Sacred Heart School
                      </span>{" "}
                      Developed by
                      <span>
                        {" "}
                        <a href="https://www.entab.in/" target="_blank">
                          Entab Infotech : CampusCare®
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
